<div class="apps-left">
    <div class="main-menu scroll-y">
        <div class="menu-tabs-container configuration">
            <div class="left-menu">
                <p-panelMenu [model]="menuMaster" [multiple]="false"></p-panelMenu>
            </div>
        </div>
        <div class="copyright bottom-fixed">
            <div class="timestamp">Date : <strong id="clockbox"></strong></div>
        </div>
    </div>
</div>